export var ESearchKeys = {
    Response: "globalSearchResult"
};
